import React, {useContext, useState} from "react";

import {NotificationsContext} from "../../ui-components/Notifications";
import apiRequest from "../../services/apiRequest";

// UI
import AddLineDialog from "../Dialogs/AddLineDialog";
import MaterialTable from "material-table";
import _ from "lodash";

// Table Params
import { COLUMNS, OPTIONS, LOCALIZATION } from "./Params/Linee";
import { tableIcons } from "../../ui-components/TableIcons";


function LineTable({ line, setLine }) {
  const { push } = useContext(NotificationsContext);
  const [showAddDialog, setShowAddDialog] = useState(false);
  const toggleDialog = () => setShowAddDialog(!showAddDialog);

  const _onRowUpdate = (newData, oldData) =>
    new Promise((resolve, reject) => {
      let isEqual = true;
      Object.entries(newData).forEach(([key, value]) => {
        if (oldData[key] !== value) {
          isEqual = false;
        }
      });
      setImmediate(() => {
        if (isEqual) {
          resolve();
        } else {
          apiRequest.post(`conf/line/${oldData.id}`, newData)
            .then((res) => {
              setLine({...line, [res['id']]: res})
              push({title: "Linea aggiornata con successo", type: "success"});
              resolve();
            })
            .catch(() => {
              push({title: "Errore imprevisto", type: "error"});
              reject();
            });
        }
      });
    });

  const _onRowDelete = (newData) =>
    new Promise((resolve, reject) => {
      setImmediate(() => {
        apiRequest.delete(`conf/line/${encodeURIComponent(newData.id)}`, newData)
          .then(() => {
            const { [newData.id]: tmp, ...rest } = line;
            setLine({ ...rest });
            push({title: "Linea eliminata", type: "success"});
            resolve();
          })
          .catch(() => {
            push({title: "Impossibile eliminare l'elemento", type: "error"});
            reject();
          });
      });
    });

  return (
    <>
      <MaterialTable
        columns={COLUMNS}
        data={line && Object.values(line)}
        icons={tableIcons}
        isLoading={line === undefined}
        options={OPTIONS}
        title={"Linee prodotto"}
        localization={LOCALIZATION}
        actions={[{
          icon: tableIcons.Add,
          tooltip: "Aggiungi linea",
          onClick: () => {toggleDialog()},
          isFreeAction: true,
        }]}
        editable={{
          onRowUpdate: _onRowUpdate,
          onRowDelete: _onRowDelete
      }}
      />
      {showAddDialog &&
      <AddLineDialog
        open={showAddDialog}
        toggleOpen={toggleDialog}
        line={line}
        setLine={setLine}
      />
      }
    </>
  );
}

export default React.memo(LineTable, (props, nextProps) => {
  return _.isEqual(props.line, nextProps.line);
});
